import { NCBI_APIKEY } from '../../../../constants';


export async function getAccessionNumberList(pmid) {
  if (pmid === null) {
    return [];
  }
  const response = await fetch(
    'https://eutils.ncbi.nlm.nih.gov/entrez/eutils/elink.fcgi?dbfrom=pubmed&' +
    `db=nuccore&id=${pmid}&retmode=json&api_key=${NCBI_APIKEY}`
  );
  const json = await response.json();
  const {linksets: [linkset]} = json;
  if (!linkset.linksetdbs) {
    return [];
  }
  const {linksetdbs: [{links}]} = linkset;
  return links;
}


export async function getAccessionNumberByPopSet(popsetid) {
  if (popsetid === null) {
    return [];
  }

  const response = await fetch(
    'https://eutils.ncbi.nlm.nih.gov/entrez/eutils/elink.fcgi?dbfrom=popset&' +
    `db=nuccore&id=${popsetid}&retmode=json&api_key=${NCBI_APIKEY}`
  );
  const json = await response.json();
  const {linksets: [linkset]} = json;
  if (!linkset.linksetdbs) {
    return [];
  }
  const {linksetdbs: [{links}]} = linkset;
  return links;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/genbank/genbank-api.js